import { Card } from "@blueprintjs/core";

import { PropertyType } from "core/decorators/PropertyType";
import ColorUtil from "core/util/ColorUtil";
import { AbstractPropertyType, PreviewDisplay } from "../../core/util/property/AbstractPropertyType";
import IPropertyRecord from "../../core/util/property/IPropertyRecord";
import { CssPropertyProvider, ICssBlock, ICssProperty } from "./CssPropertyProvider";

enum BackgroundType {
	SOLID,
	GRADIENT,
	IMAGE,
	COMBO
}

enum BackgroundPosition {
	CENTER
}

/*R
@Validate({type: ValidationTypes.NUMBER, pattern: [0.01-1]})*/
interface IBackground {
	type: BackgroundType;
	position: BackgroundPosition;
	color: { r: number, g: number, b: number};
}

@PropertyType({name: "background", label: "Background"})
class BackgroundPropertyType extends AbstractPropertyType<IBackground, ICssBlock> {

	public getDefaultValue() {
		return {
			type: BackgroundType.GRADIENT,
			position: BackgroundPosition.CENTER,
			color: {
				r: 255,
				g: 0,
				b: 0,
				a: 1
			}
		};
	}

	public getValue(stored: IBackground, wrapper: IPropertyRecord<IBackground>): ICssBlock {
		const {type, color, position} = wrapper.value;

		const css: ICssBlock = { properties: [] };

		/*switch(ca) {
			case BackgroundType.SOLID:
				value = StringUtil.format("rgba(%s, %s, %s, %s)", color.r, color.g, color.b, color.a);
				break;
			case BackgroundType.GRADIENT:
				value = "linearGradient()";
				break;
		}*/

		if(position) {
			css.properties.push({
				property: "background-position",
				value: position
			});
		}

		return css;
	}

	public getInput() {
		// this is a "composite" property. its made up of other more granular ones
		// we can the input from the other property inputs
		return undefined as any;
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/BackgroundProperty.type.tsx